import { signal } from '@preact/signals-react'

type calIdFormat = {
    id: string
    title: string
}

export const calPerm = signal<boolean>(false)

export const calIdGlobal = signal<calIdFormat>({
    id: '',
    title: '',
})

export const syncing = signal<boolean>(false)

export const calErrorMessage = signal<string>('')
